import { render } from "./ProfileUdList.vue?vue&type=template&id=9e26e63a"
import script from "./ProfileUdList.vue?vue&type=script&lang=js"
export * from "./ProfileUdList.vue?vue&type=script&lang=js"
script.render = render

export default script